import moment from 'moment';

export const formatLicenseTime = (time: string | Date) => {
  return moment(time).format('MM/DD/YYYY');
};
